// extracted by mini-css-extract-plugin
export default {"zoomModal":"B1-z","image":"C1-z","button":"D1-z","isOverlayShown":"E1-z"};